import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import "../css/main.scss";
import productData from "../Datas/productData";
import { 
  FaChevronLeft, 
  FaChevronRight, 
  FaRegHeart, 
  FaHeart,
  FaSearch, 
  FaTimes,
  FaFacebookF,
  FaTwitter,
  FaPinterestP,
  FaLinkedinIn,
  FaTelegramPlane,
  FaImage
} from "react-icons/fa";
import { CartContext } from "./CartContext";

export const ProductCard = ({ product, discountNum, onQuickView }) => {
  const { favorites, toggleFavorite: contextToggleFavorite } = useContext(CartContext) || { favorites: [], toggleFavorite: () => {} };
  const isFavorite = favorites.some((item) => item.id === product.id);

  const oldPrice = discountNum 
    ? (parseFloat(product.price) * (1 + discountNum / 100)).toFixed(2)
    : (parseFloat(product.price) + 10).toFixed(2);

  const toggleFavorite = (e) => {
    e.preventDefault();
    e.stopPropagation();
    contextToggleFavorite(product);
  };

  return (
    <div className="product-card" key={product.id}>
      <div className="product-card-main">
        <Link to={`/product/${product.id}`} className="product-image-wrap">
          {discountNum && <span className="discount-badge">-{discountNum}%</span>}
          <img src={product.image} alt={product.name} />
        </Link>
        <div className="product-info">
          <Link to={`/product/${product.id}`}>
            <h3 className="product-title">{product.name}</h3>
          </Link>
          <span className="product-category">{product.category}</span>
          <div className="product-price">
            <span className="old-price">${oldPrice}</span>
            <span className="new-price">${product.price}</span>
          </div>
        </div>
      </div>
      <div className="product-hover-content">
        <div className="product-description">
          {product.description && product.description[0]}
        </div>
        <div className="product-actions">
          <button 
            type="button"
            className="action-btn heart-btn"
            onClick={toggleFavorite}
          >
            {isFavorite ? <FaHeart color="#ff4d4f" /> : <FaRegHeart />}
          </button>
           
          <button 
            type="button"
            className="action-btn quick-view-btn" 
            onClick={(e) => onQuickView(e, product)}
          >
            <FaSearch />
          </button>
        </div>
      </div>
    </div>
  );
};

function Main() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [quickViewProduct, setQuickViewProduct] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const cartContext = useContext(CartContext);
  const addToCart = cartContext?.addToCart || (() => {});

  const handleQuickView = (e, product) => {
    e.preventDefault();
    e.stopPropagation();
    setQuickViewProduct(product);
    setQuantity(1);
  };

  const handleAddToCart = (e, product, qty = 1) => {
    e.preventDefault();
    addToCart(
      product.id,
      qty,
      product.size?.[0] || "",
      product.colors?.[0] || ""
    );
    if (quickViewProduct) {
      setQuickViewProduct(null);
    }
  };

  const decreaseQuantity = () => {
    if (quantity > 1) setQuantity(quantity - 1);
  };

  const increaseQuantity = () => {
    setQuantity(quantity + 1);
  };

  const slides = [
    {
      subtitle: "PREMIUM ELECTRONICS",
      title: "Elevate Your Gaming &\nDaily Setup",
      desc: "Smooth Operation, Immersive Sound & Precise Control",
      image: "/main/m1-1.webp",
    },
    {
      subtitle: "CURATED TECH PICKS",
      title: "Smart Peripherals for\nWork & Play",
      desc: "Comfortable, Stylish & High-Performance Accessories",
      image: "/main/m1-2.webp",
    },
  ];

  const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % slides.length);
  const prevSlide = () =>
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);

  const electronicsProducts = productData.filter((p) => p.id <= 8);

  const featuredList = [
    productData[0],
    productData[3],
    productData[6],
    productData[9],
  ].filter(Boolean);

  const rightGridProducts = productData.slice(12, 18);

  return (
    <div className="main">
      <main>
        {/* Hero Slider Section */}
        <section className="hero-slider">
          <div
            className="slider-container"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {slides.map((slide, index) => (
              <div className="slide" key={index}>
                <div className="slide-content">
                  <div className="container">
                    <div className="text-content">
                      <span className="subtitle">{slide.subtitle}</span>
                      <h2
                        dangerouslySetInnerHTML={{
                          __html: slide.title.replace(/\n/g, "<br/>"),
                        }}
                      ></h2>
                      <p>{slide.desc}</p>
                    </div>
                  </div>
                </div>
                <div
                  className="slide-image"
                  style={{ backgroundImage: `url(${slide.image})` }}
                ></div>
              </div>
            ))}
          </div>
          <button className="slider-arrow prev" onClick={prevSlide}>
            <FaChevronLeft />
          </button>
          <button className="slider-arrow next" onClick={nextSlide}>
            <FaChevronRight />
          </button>
          <div className="slider-dots">
            {slides.map((_, index) => (
              <span
                key={index}
                className={`dot ${currentSlide === index ? "active" : ""}`}
                onClick={() => setCurrentSlide(index)}
              ></span>
            ))}
          </div>
        </section>

        {/* Electronics Grid Section */}
        <section className="electronics-section">
          <div className="container">
            <div className="section-header">
              <div className="header-left">
                <h2>ELECTRONICS</h2>
              </div>
            </div>

            <div className="product-grid">
              {electronicsProducts.map((product) => (
                <ProductCard product={product} key={product.id} onQuickView={handleQuickView} />
              ))}
            </div>
          </div>
        </section>

        {/* Today Hot Deals Section */}
        <section className="hot-deals-section">
          <div className="container">
            <div className="section-title-center">
              <h2>TODAY HOT DEALS</h2>
            </div>

            <div className="hot-deals-grid">
              {productData.slice(7, 10).map((product) => (
                <ProductCard product={product} key={product.id} onQuickView={handleQuickView} />
              ))}
            </div>

            <div className="view-all-btn-wrap">
              <Link to="/shop" className="view-all-btn">
                VIEW ALL DEALS
              </Link>
            </div>
          </div>
        </section>

        {/* more-products */}
        <section className="more-products-section">
          <div className="container">
            <div className="more-products-layout">
              {/* Left Sidebar */}
              <aside className="more-sidebar">
                <div className="sidebar-banner">
                  <span className="banner-subtitle">Hich Tech News</span>
                  <h3>
                    Google Smart Home
                    <br />
                    2026
                  </h3>
                  <Link to="/shop" className="btn-read-more">
                    READ MORE
                  </Link>
                </div>

                <div className="sidebar-featured">
                  <div className="sidebar-title">FEATURED PRODUCTS</div>
                  <div className="sidebar-product-list">
                    {featuredList.map((product) => {
                      const oldPrice = (parseFloat(product.price) + 10).toFixed(
                        2
                      );
                      return (
                        <Link
                          to={`/product/${product.id}`}
                          className="mini-product-card"
                          key={product.id}
                        >
                          <div className="mini-img-wrap">
                            <img src={product.image} alt={product.name} />
                          </div>
                          <div className="mini-info">
                            <h4 className="mini-title">{product.name}</h4>
                            <div className="mini-price">
                              <span className="old-price">${oldPrice}</span>
                              <span className="new-price">
                                ${product.price}
                              </span>
                            </div>
                          </div>
                        </Link>
                      );
                    })}
                  </div>
                </div>
              </aside>

              {/* Right Content */}
              <div className="more-main">
                <div className="more-tabs">
                  <div className="tabs-left">
                    <span className="tab active">ELECTRONICS</span>
                  </div>
                </div>

                <div className="more-product-grid">
                  {rightGridProducts.map((product, idx) => {
                    const discountNum = [9, 20, 14, 20, 9, 14][idx % 6];
                    return (
                      <ProductCard product={product} discountNum={discountNum} key={product.id} onQuickView={handleQuickView} />
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Banner Section */}
        <section className="banner-section">
          <div className="container">
            <div className="banner-wrapper">
              <div className="banner-content">
                <div className="text-side">
                  <h2>
                    2026 New Purple Bluetooth Earbuds Sleep Earbuds In-Ear
                    Wireless Noise Cancelling Mini Extra-Long Battery Life
                  </h2>
                  <div className="banner-buttons">
                    <Link to="/shop" className="btn-buy">
                      BUY NOW
                    </Link>
                  </div>
                </div>
                <div className="image-side">
                  <div className="circle-image">
                    <img src="/main/m4-1.webp" alt="Girl wearing earbuds" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      {quickViewProduct && (
        <div className="quick-view-overlay" onClick={() => setQuickViewProduct(null)}>
          <div className="quick-view-modal" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setQuickViewProduct(null)}>
              <FaTimes />
            </button>
            <div className="quick-view-content">
              <div className="quick-view-image">
                <img src={quickViewProduct.image} alt={quickViewProduct.name} />
                <Link to={`/product/${quickViewProduct.id}`} className="view-details-overlay">
                  <FaImage /> VIEW DETAILS
                </Link>
              </div>
              <div className="quick-view-details">
                <h2>{quickViewProduct.name}</h2>
                <div className="price">
                  <span className="old-price">${(parseFloat(quickViewProduct.price) + 10).toFixed(2)}</span>
                  <span className="new-price">${quickViewProduct.price}</span>
                </div>
                <div className="quantity-cart">
                  <div className="quantity-selector">
                    <button onClick={decreaseQuantity}>-</button>
                    <input type="text" value={quantity} readOnly />
                    <button onClick={increaseQuantity}>+</button>
                  </div>
                  <button 
                    className="btn-add-cart"
                    onClick={(e) => handleAddToCart(e, quickViewProduct, quantity)}
                  >
                    ADD TO CART
                  </button>
                </div>
                <div className="meta">
                  <p><strong>Category:</strong> {quickViewProduct.category}</p>
                  <div className="share">
                    <strong>Share:</strong>
                    <div className="share-icons">
                      <FaFacebookF />
                      <FaTwitter />
                      <FaPinterestP />
                      <FaLinkedinIn />
                      <FaTelegramPlane />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Main;
